module.exports = __webpack_public_path__ + "static/media/citywithdots.fe6e5928.svg";